import { useEffect, useState, type ReactNode } from "react";

/**
 * Renders its children only in the browser, after the first commit.
 *
 * Public pages are prerendered at build time (scripts/prerender.mjs) and the
 * browser then hydrates that HTML: its first render must produce exactly the
 * same markup. Anything that depends on the visitor (cookie consent, session,
 * popups, chat, toasts) cannot be known at build time, so it waits for this.
 */
export function ClientOnly({ children }: { children: ReactNode }) {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  return mounted ? <>{children}</> : null;
}
